<template>
  <div class="customized-tabs-container">
    <span :class="getLeftClass" @click="transformLeft"></span>
      <div class="customized-box">
        <div class="customized-content" ref="contentElement">
          <card v-for="item in customizedData" :key="item.key" :customizedData="item" class="cards-item"/>
        </div>
      </div>
      <span :class="getRightClass"  @click="transformRight"></span>
  </div>
</template>

<script>
import card from './card.vue'

export default {
  components: { card },
  data() {
    return {
      transformX: 0,
      currentIndex: 0,
      length: 0,
      step: 0,
      rate: 286,
      contentElement: null,
      customizedData: [
        {
          key: Math.random(),
          title: '中国移动积分商城',
          content: '用户在移动积分商城使用移动积分兑换京东快递优惠券后，直发到用户的京东快递账户',
          info: {
            company: '中移动金融科技有限公司',
            department: '技术与数据智能部-快递快运技术部',
            personnel: 'dongyue31'
          }
        },
        {
          key: Math.random(),
          title: '东方甄选拒单同步商家',
          content: '东方甄选拒单同步商家',
          info: {
            company: '东方优选（北京）科技有限公司',
            department: '技术与数据智能部-供应链技术部',
            personnel: 'guoyufei2'
          }
        },
        {
          key: Math.random(),
          title: '德邦【大件转德邦】',
          content: '大件转德邦对接方案，涉及整拼车状态查询，后续支持下单取消等场景对接',
          info: {
            company: '上海燕汐软件信息科技有限公司',
            department: '技术与数据智能部-供应链技术部',
            personnel: 'luojiaqi'
          }
        },
        {
          key: Math.random(),
          title: '京东服务+【平安财险业务】',
          content: '京东服务+【平安财险业务】',
          info: {
            company: '中国平安财产保险股份有限公司',
            department: '技术与数据智能部-供应链技术部',
            personnel: 'gujian23'
          }
        },
        {
          key: Math.random(),
          title: '中铁【运力数据对接】',
          content: '中铁数据对接使用http服务，由京东同学代替客户接入',
          info: {
            company: '中铁京东物流有限公司',
            department: '技术与数据智能部-运力平台技术部',
            personnel: 'wanyuepeng1'
          }
        },
        {
          key: Math.random(),
          title: '新蓝环保【TMS对接】',
          content: 'TMS相关能力对接。包含车辆、承运商、司机相关能力',
          info: {
            company: '山东新蓝环保科技有限公司',
            department: '运力平台部-综合支持部',
            personnel: 'huangjinlei8'
          }
        },
        {
          key: Math.random(),
          title: '中福【快递附件推送】',
          content: '中福附件推送服务-电子返单',
          info: {
            company: '宜昌人福药业有限责任公司',
            department: '技术与数据智能部-快递快运技术部',
            personnel: 'zhangyong546'
          }
        },
        {
          key: Math.random(),
          title: '车辆监控数据【IoT-Hub】',
          content: 'iot-hub接收车辆监控数据',
          info: {
            company: '鱼快创领智能科技(南京)有限公司',
            department: '技术与数据智能部-运力平台技术部',
            personnel: 'wanyuepeng1'
          }
        },
        {
          key: Math.random(),
          title: '百度【京东快递】',
          content: '通过运单号来获取包裹号信息',
          info: {
            company: '上海小度技术有限公司',
            department: '技术与数据智能部-快递快运技术部',
            personnel: 'zhangyong546'
          }
        },
      ]
    }
  },
  mounted() {
    this.contentElement = this.$refs.contentElement
    this.length = this.customizedData.length
    this.step = this.customizedData.length
  },
  computed: {
    getLeftClass() {
      let className = 'customized-icon customized-icon-left'
      if (this.step === this.length || this.length <= 4) {
        className = 'customized-icon customized-icon-left deactive'
      }
      console.log('className', className)
      return className
    },
    getRightClass() {
      console.log('this.step', this.step)
      console.log('this.length', this.length)
      let className = 'customized-icon customized-icon-right'
      if (this.step <= 4 || this.length <= 4) {
        className = 'customized-icon customized-icon-right deactive'
      }
      return className
    },
  },
  methods: {
    getContentElement() {

    },
    transformLeft() {
      if (this.step === this.length || this.length <= 4) {
        return
      } if (this.length - this.step <= 4) {
        this.transformX += this.rate * (this.length - this.step)
        this.step = this.length
      } else {
        this.transformX += this.rate * 4
        this.step += 4
      }
      console.log('this.step', this.step)
      this.$nextTick(() => {
        this.contentElement.style.transform = `translateX(${this.transformX}px)`
      })
    },
    transformRight() {
      if (this.step <= 4 || this.length <= 4) {
        return
      } if (this.step >= 8) {
        this.step -= 4
        this.transformX -= this.rate * 4
      } else {
        this.transformX -= this.rate * (this.step - 4)
        this.step = 4
      }
      console.log('this.transformX', this.transformX)
      this.$nextTick(() => {
        this.contentElement.style.transform = `translateX(${this.transformX}px)`
      })
    },
  }
}
</script>

<style lang="scss">
.customized-tabs-container {
  max-width: 1144px;
  min-width: 1144px;
  max-height: 317px;
  margin-left: -16px;
  position: relative;
  .customized-icon {
    z-index: 9;
    width: 20px;
    height: 20px;
    display: block;
    background-size: cover;
    position: absolute;

    transform: translateY(-10px);
    cursor: pointer;
  }
  .customized-icon-left {
    left: -24px;
    top: 45%;
    background-image: url('~@/assets/front/pre-active.png');
    transform: rotate(180deg);
  }
  .customized-icon-right {
    right: -40px;
    top: 50%;
    background-image: url('~@/assets/front/pre-active.png');
  }
  .deactive {
    cursor: not-allowed;
    background-image: url('~@/assets/front/pre-deactive.png');
  }
}
  .customized-box {

    display: flex;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    position: relative;

    -ms-word-break: normal;
    word-break: normal;
    white-space: pre-line;
    white-space: -moz-pre-wrap;
    white-space: pre-wrap;
    white-space: nowrap;
    text-wrap: nowrap;

    &::-webkit-scrollbar {
      display: none !important;
    }
    .customized-content {
      transform: translateX(0px);
      transition-duration: .5s;
      transition-property: transform;
      transition-timing-function: cubic-bezier(.4,0,.2,1);
      transition-property: transform, -moz-transform;
    }
    .cards-item {
      display: inline-block;
      padding-left: 16px;
    }
  }
</style>
